import * as Styled from './wrapper.styles';

const Wrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return <Styled.WrapperContainer>{children}</Styled.WrapperContainer>;
};

export default Wrapper;
